module.exports = __webpack_public_path__ + "static/media/logo-mob.6d5a01c0.svg";